interface Props {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  return (
    <div className='container grid h-svh max-w-none items-center justify-center'>
      <div className='mx-auto flex w-full flex-col justify-center space-y-2 py-8 sm:p-8'>
        <div className='mb-4 flex items-center justify-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            width='24px'
            height='24px'
            viewBox='0 0 24 24'
            version='1.1'
          >
            <g id='surface1'>
              <path d='M 14.539062 4.4375 L 14.539062 8.976562 C 17.019531 7.667969 20.171875 6.785156 20.171875 6.785156 L 20.171875 3.058594 Z M 14.539062 4.4375 ' />
              <path d='M 13.207031 4.8125 L 0.238281 8.046875 L 0.238281 12.617188 L 3.839844 11.734375 L 3.839844 16.664062 C 6.277344 14.488281 9.476562 12.167969 9.476562 12.167969 L 9.476562 10.332031 L 13.207031 9.410156 Z M 13.207031 4.8125 ' />
              <path d='M 14.539062 10.546875 L 14.539062 13.679688 L 10.761719 14.625 L 10.761719 19.171875 L 23.761719 15.972656 C 23.761719 15.972656 23.761719 11.429688 23.761719 11.378906 C 23.761719 11.410156 20.363281 12.207031 20.171875 12.246094 C 20.148438 8.621094 20.183594 7.707031 20.171875 7.667969 C 20.160156 7.621094 17.066406 8.945312 14.539062 10.546875 Z M 14.539062 10.546875 ' />
              <path d='M 3.839844 20.4375 L 3.839844 20.941406 C 3.839844 20.941406 8.632812 19.777344 9.476562 19.558594 L 9.476562 14.1875 C 7.382812 15.984375 5.050781 18.976562 3.839844 20.4375 Z M 3.839844 20.4375 ' />
            </g>
          </svg>

          <h1 className='text-xl font-medium'>Tennistalker Backoffice</h1>
        </div>
        {children}
      </div>
    </div>
  )
}
